import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: null,
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.DOSE_REMINDER_DATA_REQUEST:
      return {
        ...state,
        data: null,
        isProgress: true,
      };
    case homeConstants.DOSE_REMINDER_DATA_SUCCESS:
      return {
        data: action.response.data,
        isProgress: false,
      };
    case homeConstants.DOSE_REMINDER_DATA_FAILURE:
      return {
        data: null,
        error: action.error,
        isProgress: false,
      };
    case homeConstants.RESET_DOSE_REMINDER_DATA:
      return {
        ...state,
        data: null,
      };
    default:
      return state;
  }
}
